import React from 'react';

import {Campaign, CampaignTypes} from '../../../../../../types/src';
import {InfoIcon, getCampaignTypes, brandConfig} from '../../../../../../ui/src';

interface CampaignDetailsTitleProps {
  campaign: Campaign;
}

export function CampaignDetailsTitle({campaign}: Readonly<CampaignDetailsTitleProps>): string | React.ReactNode {
  if (!campaign) {
    return null;
  }
  const type = getCampaignTypes(campaign.type);
  if (campaign.type !== CampaignTypes.AcquisitionViaImport) {
    return type.value;
  }
  return (
    <>
      <span>{type.value}: </span>
      <InfoIcon
        message={
          <span>
            If you need to send over 100 invites per week, use this type of campaign in addition to your regular
            Acquisition campaigns.
            {!brandConfig.isAffiliate && (
              <>
                <span>Follow the instructions by clicking&nbsp;</span>
                <a
                  style={{textDecoration: 'underline'}}
                  href={brandConfig.articles.acquisitionCampaignEmail}
                  target="_blank"
                  rel="noreferrer"
                >
                  here.
                </a>
              </>
            )}
          </span>
        }
      />
    </>
  );
}
